import {
	MTLLoader
} from 'three/examples/jsm/loaders/MTLLoader';
import {
	OBJLoader
} from 'three/examples/jsm/loaders/OBJLoader';

export const LoadOBJ = {
	data() {
		return {
			currOBJ: '',
			OBJMesh: {
				mtl: '/assets/建筑模型.mtl',
				obj: '/assets/建筑模型.obj',
				rotation: [-1.58, 0, 0],
				scale: [10, 10, 10],
				position: [0, 0, 0],
			}
		}
	},
	methods: {
		loadMTLOBJ(OBJMesh, callback = () => { }, success = () => { }, error = () => { }) {
			this.OBJMesh = Object.assign({}, this.OBJMesh, OBJMesh);
			const mtlLoader = new MTLLoader();
			mtlLoader.load(
				this.OBJMesh.mtl,
				material => {
					material.preload();
					var loader = new OBJLoader();
					loader.setMaterials(material);
					loader.load(
						this.OBJMesh.obj,
						(obj) => {
							let object = obj;
							object.name = null
							object.objId = null
							object.objType = null
							if (OBJMesh.side)
								object.traverse(function (child) {
									if (child.material) {
										child.material.side = THREE.DoubleSide;
									}
								});
							object.renderOrder = 1;
							object.rotation.set(...this.OBJMesh.rotation);
							object.scale.set(...this.OBJMesh.scale);
							object.position.set(...this.OBJMesh.position);
							object.receiveShadow = true;
							if (this.OBJMesh.name)
								object.name = this.OBJMesh.name;
							if (this.OBJMesh.id)
								object.objId = this.OBJMesh.id;
							if (this.OBJMesh.objType)
								object.objType = this.OBJMesh.objType;
							this.scene.add(object);
							this.currOBJ = object
							if (callback) callback(object)
						},
						() => {
							this.onProgress;
							if (success) success()
						},
						() => {
							this.onError;
							if (error) error()
						}
					);
				}
			);
		},
		onProgress(xhr) {
			if (xhr.lengthComputable) {
				console.info('添加成功')
				var percentComplete = (xhr.loaded / xhr.total) * 100;
			}
		},
		onError(xhr) {
			console.error('添加失败', xhr);
		},
		meshEach(mesh, method) {
			mesh.traverse((child) => {
				if (child instanceof THREE.Mesh) {
					method(child)
				}
			});
		}
	},
}
